/**
 * 财务中心 - 退票退款登记页
 *
 * 财务录入退票/退款记录，支持多条件筛选查询、新增、审核、删除操作：
 * 1. 查询条件：收款人姓名（模糊）、证件号码（精确）、服务商、审核状态、类型、税期、录入时间范围
 * 2. 列表展示：登记单号、类型、审核状态、收款人、证件号、服务商、税期、金额、税额、录入人、录入时间
 * 3. 操作：新增退款/退票记录、查看详情、审核（通过/驳回）、删除（仅待审核可删）
 */
<template>
  <div class="refund-records-page">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>财务中心</el-breadcrumb-item>
      <el-breadcrumb-item>退票退款登记</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="search-section">
      <el-form :model="formInline" size="small" label-width="90px" class="search-form">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="收款人姓名">
              <el-input v-model="formInline.payeeName" placeholder="请输入收款人姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="证件号码">
              <el-input v-model="formInline.idNo" placeholder="请输入证件号码" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="服务商">
              <el-select v-model="formInline.distributeCompanyId" filterable clearable placeholder="请选择服务商" style="width: 100%">
                <el-option v-for="c in companyOptions" :key="c.id" :label="c.name" :value="c.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="审核状态">
              <el-select v-model="formInline.auditStatus" clearable placeholder="请选择" style="width: 100%">
                <el-option label="待审核" :value="0"></el-option>
                <el-option label="已生效" :value="1"></el-option>
                <el-option label="已驳回" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="税期年份">
              <el-date-picker v-model="formInline.taxYear" type="year" value-format="yyyy" placeholder="选择年份" style="width: 100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="税期月份">
              <el-select v-model="formInline.taxMonth" clearable placeholder="请选择" style="width: 100%">
                <el-option v-for="m in 12" :key="m" :label="m + '月'" :value="m"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="录入时间">
              <el-date-picker
                v-model="formInline.dateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label=" ">
              <el-button type="primary" size="mini" icon="el-icon-search" @click="search">查询</el-button>
              <el-button size="mini" icon="el-icon-refresh-left" @click="reset">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>

    <div class="toolbar">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      <el-button size="small" type="success" icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出</el-button>
    </div>

    <el-card shadow="hover" class="table-card">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="加载中..."
        empty-text="暂无数据"
        style="width: 100%"
        border
      >
        <el-table-column prop="recordNo" label="登记单号" min-width="150" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span @dblclick="copyText(row.recordNo, '登记单号')" style="cursor: pointer;">{{ row.recordNo }}</span>
          </template>
        </el-table-column>
        <el-table-column label="类型" width="70" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" :type="row.recordType === 1 ? 'danger' : 'warning'" effect="plain">
              {{ row.recordType === 1 ? '退款' : '退票' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="statusTagType(row.auditStatus)" size="small" effect="plain">{{ statusText(row.auditStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="payeeName" label="收款人" width="100" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span @dblclick="copyText(row.payeeName, '收款人')" style="cursor: pointer;">{{ row.payeeName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="idNo" label="证件号码" min-width="160" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span @dblclick="copyText(row.idNo, '证件号码')" style="cursor: pointer;">{{ row.idNo }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="distributeCompanyName" label="服务商" min-width="140" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span @dblclick="copyText(row.distributeCompanyName, '服务商')" style="cursor: pointer;">{{ row.distributeCompanyName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="税期" width="90" align="center">
          <template slot-scope="{ row }">{{ row.taxYear }}-{{ String(row.taxMonth).padStart(2, '0') }}</template>
        </el-table-column>
        <el-table-column label="退款金额" width="110" align="right">
          <template slot-scope="{ row }">{{ formatAmount(row.amount) }}</template>
        </el-table-column>
        <el-table-column label="冲减个税" width="100" align="right">
          <template slot-scope="{ row }">{{ formatAmount(row.individualIncomeTax) }}</template>
        </el-table-column>
        <el-table-column label="冲减增值税" width="100" align="right">
          <template slot-scope="{ row }">{{ formatAmount(row.valueAddedTax) }}</template>
        </el-table-column>
        <el-table-column prop="sourceBatchNumber" label="批次ID" min-width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span @dblclick="copyText(row.sourceBatchNumber, '批次ID')" style="cursor: pointer;">{{ row.sourceBatchNumber || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sourceDetailId" label="详情ID" min-width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span @dblclick="copyText(row.sourceDetailId, '详情ID')" style="cursor: pointer;">{{ row.sourceDetailId || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reason" label="备注" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="creator" label="录入人" width="90" show-overflow-tooltip></el-table-column>
        <el-table-column label="录入时间" width="160">
          <template slot-scope="{ row }">{{ formatTimestamp(row.createdAt) }}</template>
        </el-table-column>
        <el-table-column prop="auditor" label="审核人" width="90" show-overflow-tooltip></el-table-column>
        <el-table-column label="审核时间" width="160">
          <template slot-scope="{ row }">{{ row.auditAt ? formatTimestamp(row.auditAt) : '-' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="160" fixed="right" align="center">
          <template slot-scope="{ row }">
            <el-button size="mini" type="primary" plain @click="handleAudit(row)">审核</el-button>
            <el-button size="mini" type="danger" plain @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </div>
    </el-card>

    <!-- 新增弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="580px"
      class="edit-form-dialog"
      :close-on-click-modal="false"
      @closed="resetForm"
    >
      <el-form ref="refundForm" :model="refundForm" :rules="formRules" label-width="110px" size="small">
        <el-form-item label="收款人姓名" prop="payeeName">
          <el-input v-model="refundForm.payeeName" placeholder="请输入收款人姓名" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="证件号码" prop="idNo">
          <el-input v-model="refundForm.idNo" placeholder="请输入证件号码" maxlength="18"></el-input>
        </el-form-item>
        <el-form-item label="服务商" prop="distributeCompanyId">
          <el-select v-model="refundForm.distributeCompanyId" filterable placeholder="请选择服务商" style="width: 100%">
            <el-option v-for="c in companyOptions" :key="c.id" :label="c.name" :value="c.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="税期年份" prop="taxYear">
          <el-date-picker v-model="refundForm.taxYear" type="year" value-format="yyyy" placeholder="选择年份" style="width: 100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="税期月份" prop="taxMonth">
          <el-select v-model="refundForm.taxMonth" placeholder="选择月份" style="width: 100%">
            <el-option v-for="m in 12" :key="m" :label="m + '月'" :value="m"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退款金额" prop="amount">
          <el-input-number v-model="refundForm.amount" :precision="2" :min="0.01" :max="99999999.99" placeholder="请输入金额" style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item label="原结算批次号" prop="sourceBatchNumber">
          <el-input v-model="refundForm.sourceBatchNumber" placeholder="请输入原结算批次号（选填）" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="原结算明细ID" prop="sourceDetailId">
          <el-input v-model="refundForm.sourceDetailId" placeholder="请输入原结算明细ID（选填）" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="原因" prop="reason">
          <el-input v-model="refundForm.reason" type="textarea" :rows="3" placeholder="请输入退款/退票原因（选填）" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 详情弹窗 -->
    <!-- 已移除，字段已添加到列表 -->

    <!-- 审核弹窗 -->
    <el-dialog title="审核" :visible.sync="auditDialogVisible" width="420px" class="edit-form-dialog" :close-on-click-modal="false">
      <el-form ref="auditForm" :model="auditForm" :rules="auditRules" label-width="90px" size="small">
        <el-form-item label="审核结果" prop="pass">
          <el-radio-group v-model="auditForm.pass">
            <el-radio :label="true">通过</el-radio>
            <el-radio :label="false">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="auditForm.pass === false" label="驳回原因" prop="rejectReason">
          <el-input v-model="auditForm.rejectReason" type="textarea" :rows="3" placeholder="请输入驳回原因" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="auditDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="auditLoading" @click="handleAuditSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRefundRecordList,
  getRefundRecordDetail,
  createRefundRecord,
  auditRefundRecord,
  deleteRefundRecord,
  exportRefundRecords,
  getDisCompanyNames
} from '@/api/userMG';
import Pagination from '@/components/Pagination';

export default {
  name: 'FinanceRefundRecords',
  components: {
    Pagination
  },
  data() {
    return {
      // 服务商下拉选项
      companyOptions: [],
      // 加载状态
      loading: false,
      // 列表数据
      listData: [],
      // 查询条件
      formInline: {
        page: 1,
        pageSize: 10,
        payeeName: '',
        idNo: '',
        distributeCompanyId: '',
        auditStatus: '',
        recordType: '',
        taxYear: '',
        taxMonth: '',
        dateRange: null
      },
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      // 新增弹窗
      dialogVisible: false,
      dialogTitle: '新增登记',
      submitLoading: false,
      refundForm: {
        payeeName: '',
        idNo: '',
        distributeCompanyId: '',
        taxYear: '',
        taxMonth: '',
        amount: null,
        sourceBatchNumber: '',
        sourceDetailId: '',
        reason: ''
      },
      formRules: {
        payeeName: [{ required: true, message: '请输入收款人姓名', trigger: 'blur' }],
        idNo: [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
          { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的身份证号', trigger: 'blur' }
        ],
        distributeCompanyId: [{ required: true, message: '请选择服务商', trigger: 'change' }],
        taxYear: [{ required: true, message: '请选择税期年份', trigger: 'change' }],
        taxMonth: [{ required: true, message: '请选择税期月份', trigger: 'change' }],
        amount: [{ required: true, message: '请输入退款金额', trigger: 'blur' }]
      },
      // 审核弹窗
      auditDialogVisible: false,
      auditLoading: false,
      currentAuditId: null,
      exportLoading: false,
      auditForm: {
        pass: true,
        rejectReason: ''
      },
      auditRules: {
        pass: [{ required: true, message: '请选择审核结果', trigger: 'change' }],
        rejectReason: [{ required: true, message: '请输入驳回原因', trigger: 'blur' }]
      }
    };
  },
  created() {
    this.loadCompanyOptions();
    this.getdata(this.formInline);
  },
  methods: {
    // 加载服务商下拉
    async loadCompanyOptions() {
      try {
        const res = await getDisCompanyNames({ type: 2, page: 1, pageSize: 99999 });
        if (res && res.code === 0) {
          const list = res.data || [];
          // 后端返回格式：{label: "xxx", value: xxx}
          this.companyOptions = list.map(c => ({
            id: c.value,
            name: c.label
          }));
        }
      } catch (e) {
        // 静默处理
      }
    },
    // 获取列表数据
    getdata(parameter) {
      const params = {
        page: parameter.page,
        pageSize: parameter.pageSize
      };
      if (parameter.payeeName) params.payeeName = parameter.payeeName;
      if (parameter.idNo) params.idNo = parameter.idNo;
      if (parameter.distributeCompanyId) params.distributeCompanyId = parameter.distributeCompanyId;
      if (parameter.auditStatus !== '' && parameter.auditStatus !== null) params.auditStatus = parameter.auditStatus;
      if (parameter.recordType) params.recordType = parameter.recordType;
      if (parameter.taxYear) params.taxYear = parameter.taxYear;
      if (parameter.taxMonth) params.taxMonth = parameter.taxMonth;
      if (parameter.dateRange && parameter.dateRange.length === 2) {
        params.startDate = parameter.dateRange[0];
        params.endDate = parameter.dateRange[1];
      }
      this.loading = true;
      getRefundRecordList(params)
        .then((res) => {
          this.loading = false;
          if (res && res.code === 0) {
            const data = res.data || {};
            // 后端返回格式：{totalPage, pageSize, page, totalCount, items}
            this.listData = data.items || [];
            this.pageparm.page = data.page || parameter.page;
            this.pageparm.pageSize = data.pageSize || parameter.pageSize;
            this.pageparm.total = data.totalCount || 0;
          } else {
            this.$message.error((res && res.msg) || '查询失败');
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error('菜单加载失败，请稍后再试！');
        });
    },
    // 搜索
    search() {
      this.formInline.page = 1;
      this.getdata(this.formInline);
    },
    // 清空
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        payeeName: '',
        idNo: '',
        distributeCompanyId: '',
        auditStatus: '',
        recordType: '',
        taxYear: '',
        taxMonth: '',
        dateRange: null
      };
      this.getdata(this.formInline);
    },
    // 分页事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 新增
    handleAdd() {
      this.dialogTitle = '新增登记';
      this.dialogVisible = true;
    },
    // 审核
    handleAudit(row) {
      this.currentAuditId = row.id;
      this.auditForm = { pass: true, rejectReason: '' };
      this.auditDialogVisible = true;
    },
    // 审核提交
    handleAuditSubmit() {
      this.$refs.auditForm.validate((valid) => {
        if (!valid) return;
        this.auditLoading = true;
        auditRefundRecord(this.currentAuditId, this.auditForm)
          .then((res) => {
            this.auditLoading = false;
            if (res && res.code === 0) {
              this.$message.success('审核成功');
              this.auditDialogVisible = false;
              this.getdata(this.formInline);
            } else {
              this.$message.error((res && res.msg) || '审核失败');
            }
          })
          .catch((err) => {
            this.auditLoading = false;
            this.$message.error('审核失败');
          });
      });
    },
    // 删除
    handleDelete(row) {
      this.$confirm('确认删除该条记录？删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteRefundRecord(row.id)
          .then((res) => {
            if (res && res.code === 0) {
              this.$message.success('删除成功');
              this.getdata(this.formInline);
            } else {
              this.$message.error((res && res.msg) || '删除失败');
            }
          })
          .catch((err) => {
            this.$message.error('删除失败');
          });
      }).catch(() => {});
    },
    // 提交表单
    handleSubmit() {
      this.$refs.refundForm.validate((valid) => {
        if (!valid) return;
        this.submitLoading = true;
        const data = {
          recordType: 1,
          payeeName: this.refundForm.payeeName,
          idNo: this.refundForm.idNo,
          distributeCompanyId: this.refundForm.distributeCompanyId,
          taxYear: Number(this.refundForm.taxYear),
          taxMonth: this.refundForm.taxMonth,
          amount: this.refundForm.amount
        };
        if (this.refundForm.sourceBatchNumber) data.sourceBatchNumber = this.refundForm.sourceBatchNumber;
        if (this.refundForm.sourceDetailId) data.sourceDetailId = this.refundForm.sourceDetailId;
        if (this.refundForm.reason) data.reason = this.refundForm.reason;
        createRefundRecord(data)
          .then((res) => {
            this.submitLoading = false;
            if (res && res.code === 0) {
              this.$message.success('新增成功');
              this.dialogVisible = false;
              this.getdata(this.formInline);
            } else {
              this.$message.error((res && res.msg) || '新增失败');
            }
          })
          .catch((err) => {
            this.submitLoading = false;
            this.$message.error('新增失败');
          });
      });
    },
    // 导出 Excel
    handleExport() {
      this.exportLoading = true;
      const params = {
        page: this.formInline.page,
        pageSize: this.formInline.pageSize
      };
      if (this.formInline.payeeName) params.payeeName = this.formInline.payeeName;
      if (this.formInline.idNo) params.idNo = this.formInline.idNo;
      if (this.formInline.distributeCompanyId) params.distributeCompanyId = this.formInline.distributeCompanyId;
      if (this.formInline.auditStatus !== '' && this.formInline.auditStatus !== null) params.auditStatus = this.formInline.auditStatus;
      if (this.formInline.recordType) params.recordType = this.formInline.recordType;
      if (this.formInline.taxYear) params.taxYear = this.formInline.taxYear;
      if (this.formInline.taxMonth) params.taxMonth = this.formInline.taxMonth;
      if (this.formInline.dateRange && this.formInline.dateRange.length === 2) {
        params.startDate = this.formInline.dateRange[0];
        params.endDate = this.formInline.dateRange[1];
      }
      exportRefundRecords(params)
        .then((res) => {
          this.exportLoading = false;
          if (res && res.code === 0 && res.data && res.data.downloadUrl) {
            // 触发浏览器下载
            window.open(res.data.downloadUrl, '_blank');
            this.$message.success('导出成功');
          } else {
            this.$message.error((res && res.msg) || '导出失败');
          }
        })
        .catch((err) => {
          this.exportLoading = false;
          this.$message.error('导出失败');
        });
    },
    // 重置表单
    resetForm() {
      this.$refs.refundForm && this.$refs.refundForm.resetFields();
      this.refundForm = {
        payeeName: '',
        idNo: '',
        distributeCompanyId: '',
        taxYear: '',
        taxMonth: '',
        amount: null,
        sourceBatchNumber: '',
        sourceDetailId: '',
        reason: ''
      };
    },
    // 复制文本
    copyText(text, fieldName) {
      if (!text || text === '-') {
        this.$message.warning('无内容可复制');
        return;
      }
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        this.$message.success(`${fieldName}已复制到剪贴板`);
      } catch (err) {
        this.$message.error('复制失败');
      }
      document.body.removeChild(textarea);
    },
    // 审核状态文案
    statusText(status) {
      const map = { 0: '待审核', 1: '已生效', 2: '已驳回' };
      return map[status] || '';
    },
    // 审核状态标签类型
    statusTagType(status) {
      const map = { 0: 'warning', 1: 'success', 2: 'danger' };
      return map[status] || 'info';
    },
    // 格式化金额
    formatAmount(val) {
      if (val === null || val === undefined || val === '') return '-';
      return Number(val).toFixed(2);
    },
    // 格式化时间戳（秒级）
    formatTimestamp(ts) {
      if (!ts) return '-';
      const d = new Date(ts * 1000);
      const Y = d.getFullYear();
      const M = String(d.getMonth() + 1).padStart(2, '0');
      const D = String(d.getDate()).padStart(2, '0');
      const h = String(d.getHours()).padStart(2, '0');
      const m = String(d.getMinutes()).padStart(2, '0');
      const s = String(d.getSeconds()).padStart(2, '0');
      return `${Y}-${M}-${D} ${h}:${m}:${s}`;
    }
  }
};
</script>

<style scoped>
.refund-records-page {
  padding-bottom: 24px;
}
.page-breadcrumb {
  margin-bottom: 0;
}
.search-section {
  margin-top: 24px;
  margin-bottom: 16px;
  padding: 20px 24px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.search-form .el-form-item {
  margin-bottom: 18px;
}
.search-form .el-form-item__label {
  color: #606266;
  font-size: 14px;
  text-align: right;
}
.search-form .el-input,
.search-form .el-select,
.search-form .el-date-editor {
  width: 100%;
}
.search-form .el-button {
  margin-left: 8px;
}
.toolbar {
  margin: 16px 0;
}
.table-card {
  border-radius: 8px;
  overflow: hidden;
}
/* 列表数据单行展示，超出部分省略号（配合 show-overflow-tooltip） */
.table-card >>> .el-table td .cell {
  white-space: nowrap;
}
.table-card >>> .el-card__body {
  padding: 20px;
}
.edit-form-dialog >>> .el-dialog {
  border-radius: 8px;
}
.edit-form-dialog >>> .el-dialog__header {
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
}
.edit-form-dialog >>> .el-dialog__title {
  font-size: 16px;
  color: #303133;
}
.edit-form-dialog >>> .el-dialog__body {
  padding: 16px 20px 10px;
}
.edit-form-dialog >>> .el-dialog__body .el-form-item {
  margin-bottom: 10px;
}
.edit-form-dialog >>> .el-dialog__footer {
  padding: 12px 20px 20px;
  text-align: right;
}
.pagination-wrap {
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/finance/refundRecords.vue